import React from 'react';
import { Slider, Handles } from 'react-compound-slider';
import { styles } from './slider.styles';

export function Handle({
  handle: { id, value, percent },
  getHandleProps,
}) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: -15,
        marginTop: 25,
        zIndex: 2,
        width: 30,
        height: 30,
        border: 0,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '50%',
        backgroundColor: '#2C4870',
        color: '#333',
      }}
      {...getHandleProps(id)}
    />
  );
}

export default function CustomizeSlider(props) {
  const { sharedStates, commands } = props;

  return (
    <Slider
      rootStyle={styles.sliderStyle}
      domain={[0, 2]}
      values={[sharedStates.imageScale]}
      step={0.01}
      onUpdate={commands.handleResizeImage}
      onChange={commands.handleResizeImage}
    >
      <div style={styles.railStyle} />
      <Handles>
        {({ handles, getHandleProps }) => (
          <div className="slider-handles">
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                getHandleProps={getHandleProps}
              />
            ))}
          </div>
        )}
      </Handles>
    </Slider>
  );
}
